module.exports = __webpack_public_path__ + "img/card-franchaisors1.aaf6dc0d.svg";